import type { VoucherForCampaign_EditPageQuery } from "@/lib/gql/__generated__/graphql";

import { useTransitionBlock } from "@/hooks/use-transition-block";

import { FeatureIslandContainer, FeatureIslandHeader } from "@/components/features/_layouts";

import { MarketingExistingCampaignFormModelContextProvider } from "./context";
import { useInitialized } from "../../model/usecase/existing/use-init";
import { QuestionCampaignBase } from "../_shared/components/base/root";
import { QuestionCampaignList } from "../_shared/components/list/root";
import { HeaderPublishButton } from "./components/header/publish-button/publish-button";
import { HeaderUpdateButton } from "./components/header/update-button/update-button";

type Props = {
	serverModel: VoucherForCampaign_EditPageQuery;
};

export const CampaignEditPresenter = ({ serverModel }: Props) => {
	const init = useInitialized({ serverModel });
	const { isDirty } = init.viewModel;

	useTransitionBlock(isDirty);

	return (
		<MarketingExistingCampaignFormModelContextProvider value={{ ...init }}>
			<FeatureIslandContainer>
				<FeatureIslandHeader
					title="キャンペーンの編集"
					rightChildren={
						<div className="flex gap-x-6">
							<HeaderUpdateButton />
							<HeaderPublishButton />
						</div>
					}
				/>

				<QuestionCampaignList />
				<QuestionCampaignBase />
			</FeatureIslandContainer>
		</MarketingExistingCampaignFormModelContextProvider>
	);
};

CampaignEditPresenter.displayName = "CampaignEditPresenter";
